import { useState } from "react";
import { Loading, Step, StepLabel, Stepper } from "../../../components";
import { Minimal } from "../../../layouts";
import { history, notification } from "../../../services";
import {
  enviarEmLotes,
  marcarTitulosRepetidos,
  mensagemResultado,
  validarTitulosComErro,
} from "../importar-titulos";
import ImportarTitulosActions from "./importar-titulos-actions.component";
import SelecionarArquivo from "./selecionar-arquivo.component";
import TitulosGrid from "./titulos-grid.component";

const ImportarTitulos = ({
  tituloTela,
  colunas,
  montarTitulos,
  service,
  rotaListagem,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [arquivo, setArquivo] = useState(null);
  const [titulos, setTitulos] = useState([]);

  const steps = [
    { titulo: "Selecionar Arquivo", funcaoAcao: lerArquivo },
    { titulo: "Títulos", funcaoAcao: cadastrarTitulos },
  ];

  async function lerArquivo() {
    if (!arquivo) {
      throw new Error("Por favor, selecione a planilha que será importada");
    }
    const titulosPlanilha = await montarTitulos(arquivo);
    marcarTitulosRepetidos(titulosPlanilha);
    setTitulos(titulosPlanilha);
  }

  async function cadastrarTitulos() {
    validarTitulosComErro(titulos);
    const resultado = await enviarEmLotes(titulos, service);
    notification.sucessoGenericos(mensagemResultado(resultado));
    history.push(rotaListagem);
  }

  return (
    <>
      <Minimal
        title={tituloTela}
        cardAction={
          <ImportarTitulosActions
            steps={steps}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setLoading={setLoading}
          />
        }
      >
        <Stepper activeStep={activeStep}>
          {steps.map(({ titulo }) => (
            <Step key={titulo}>
              <StepLabel>{titulo}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === 0 ? (
          <SelecionarArquivo arquivo={arquivo} setArquivo={setArquivo} />
        ) : (
          <TitulosGrid titulos={titulos} colunas={colunas} />
        )}
      </Minimal>
      <Loading loading={loading} />
    </>
  );
};

export default ImportarTitulos;
